import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "count", "to", "isActive"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { NavLink, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { breakpoints, spacing } from 'styles/globals';
import config from 'utils/config';
import { isHelixOnlyHub } from 'utils/helix';
import { PROFILE_ROUTES } from 'utils/routes';
import { toRelativePaths } from 'utils/routes/toRelativePaths';
import { useFetchUserProfile } from 'actions/userProfile';
import { useFetchMyContentStats } from 'actions/content';
import { useFetchUserHelixAccess } from 'actions/users';
import Box from 'components/Box';
import PageSection from 'components/PageSection';
import ScrollableNav from 'components/ScrollableNav';
import NavBarTab from 'components/Tab/NavBarTab';
import PageTitle from 'components/PageTitle';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import UserSkillsWidget from 'screens/UserSkills';
import UserHeader from './UserHeader';
import UserProgress from './UserProgress';
import Saved from './saved';
import History from './history';
import Upcoming from './upcoming';
import Badges from './badges';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function getFirstTabToDisplay(_ref) {
  var skillsTabFirstTab = _ref.skillsTabFirstTab,
    hasUpcomingTab = _ref.hasUpcomingTab,
    hasSavedItems = _ref.hasSavedItems;
  if (skillsTabFirstTab) {
    return PROFILE_ROUTES.skills;
  } else if (hasUpcomingTab) {
    return PROFILE_ROUTES.upcoming;
  } else if (hasSavedItems) {
    return PROFILE_ROUTES.saved;
  } else {
    return PROFILE_ROUTES.history;
  }
}
var LEGACY_PROFILE_ROUTES = ['playlists', 'assets', 'favourites'];
var PROFILE_REL = toRelativePaths(PROFILE_ROUTES, PROFILE_ROUTES.root);
var HeaderGrid = styled.div.withConfig({
  displayName: "profile__HeaderGrid",
  componentId: "sc-exeeq-0"
})(["display:flex;align-items:center;padding-top:", ";@media (max-width:", "){flex-direction:column;}"], spacing.m, breakpoints.xs);
var HeaderGridMain = styled.div.withConfig({
  displayName: "profile__HeaderGridMain",
  componentId: "sc-exeeq-1"
})(["flex-grow:1;flex-shrink:1;@media (max-width:", "){margin-bottom:", ";}"], breakpoints.xs, spacing.m);
function ProfileTab(_ref2) {
  var children = _ref2.children,
    count = _ref2.count,
    to = _ref2.to,
    isActive = _ref2.isActive,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsxs(NavBarTab, _objectSpread(_objectSpread({
    as: NavLink,
    to: to,
    className: isActive ? 'is-active' : '',
    height: 60,
    stackBelow: "xxs"
  }, otherProps), {}, {
    children: [children, Boolean(count) &&
    /*#__PURE__*/
    // NOTE: <Pill /> is not being used here as it does not resize on mobile view
    _jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsx(Box, {
        borderRadius: "circular",
        background: "shaded",
        display: "inline-block",
        children: /*#__PURE__*/_jsx(Text, {
          bold: true,
          px: "xs",
          children: count
        })
      })]
    })]
  }));
}
function ProfilePage() {
  var _userProfile$learning, _userProfile$learning2, _userProfile$learning3, _userProfile$learning4;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data,
    isUserProfileLoading = _useFetchUserProfile.isLoading;
  var _useFetchMyContentSta = useFetchMyContentStats(),
    items = _useFetchMyContentSta.items,
    isContentStatsLoading = _useFetchMyContentSta.isLoading;
  var _useFetchUserHelixAcc = useFetchUserHelixAccess(),
    helixAccessData = _useFetchUserHelixAcc.data,
    isHelixAccessLoading = _useFetchUserHelixAcc.isLoading;
  var isLoading = isUserProfileLoading || isContentStatsLoading || isHelixAccessLoading || !userProfile || !items;
  if (isLoading) {
    return /*#__PURE__*/_jsx(Landmark, {
      icon: "spinner"
    });
  }
  var savedCount = items.savedCount,
    badgesTotalCount = items.badgesTotalCount,
    badgesAwardedCount = items.badgesAwardedCount,
    upcomingCount = items.upcomingCount;
  var badges = config.badges;
  var assetsCount = (_userProfile$learning = userProfile === null || userProfile === void 0 || (_userProfile$learning2 = userProfile.learning_progress) === null || _userProfile$learning2 === void 0 ? void 0 : _userProfile$learning2.totalCompletedAssets) !== null && _userProfile$learning !== void 0 ? _userProfile$learning : 0;
  var totalMinutes = (_userProfile$learning3 = userProfile === null || userProfile === void 0 || (_userProfile$learning4 = userProfile.learning_progress) === null || _userProfile$learning4 === void 0 ? void 0 : _userProfile$learning4.totalLearningTime) !== null && _userProfile$learning3 !== void 0 ? _userProfile$learning3 : 0;
  var badgesLockedCount = badgesTotalCount - badgesAwardedCount;
  var hasBadgeTab = badges && badgesTotalCount > 0;
  var hasUpcomingTab = upcomingCount > 0;
  var hasSkillsTab = Boolean((helixAccessData === null || helixAccessData === void 0 ? void 0 : helixAccessData.hasAccess) || (helixAccessData === null || helixAccessData === void 0 ? void 0 : helixAccessData.otherHelixDomain));
  var skillsTabFirstTab = Boolean(helixAccessData === null || helixAccessData === void 0 ? void 0 : helixAccessData.isBeingAnalysed);
  var firstTabToDisplay = getFirstTabToDisplay({
    skillsTabFirstTab: skillsTabFirstTab,
    hasUpcomingTab: hasUpcomingTab,
    hasSavedItems: savedCount > 0
  });
  var isSkillsActive = pathname.startsWith(PROFILE_ROUTES.skills);
  var isUpcomingActive = pathname.startsWith(PROFILE_ROUTES.upcoming);
  var isSavedActive = pathname.startsWith(PROFILE_ROUTES.saved);
  var isBadgesActive = pathname.startsWith(PROFILE_ROUTES.badges);
  var isHistoryActive = pathname.startsWith(PROFILE_ROUTES.history);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PageTitle, {
      visuallyHidden: true,
      children: t(isHelixOnlyHub ? 'navbar_my_skills' : 'navbar_profile')
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsxs(HeaderGrid, {
        children: [/*#__PURE__*/_jsx(HeaderGridMain, {
          children: /*#__PURE__*/_jsx(UserHeader, {
            profile: userProfile
          })
        }), /*#__PURE__*/_jsx(UserProgress, {
          totalMinutes: totalMinutes,
          assetCount: assetsCount
        })]
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(Box, {
        borderBottom: "thin",
        px: "xxs",
        children: /*#__PURE__*/_jsxs(ScrollableNav, {
          spacing: "l",
          children: [hasSkillsTab && /*#__PURE__*/_jsx(ProfileTab, {
            to: PROFILE_ROUTES.skills,
            isActive: isSkillsActive,
            icon: "asset-fluidbook",
            children: t('content_type_skill_plural')
          }), hasUpcomingTab && /*#__PURE__*/_jsx(ProfileTab, {
            to: PROFILE_ROUTES.upcoming,
            isActive: isUpcomingActive,
            icon: "time",
            count: upcomingCount,
            children: t('upcoming_title')
          }), /*#__PURE__*/_jsx(ProfileTab, {
            to: PROFILE_ROUTES.saved,
            isActive: isSavedActive,
            icon: "favourite",
            count: savedCount,
            children: t('saved_for_later_title')
          }), hasBadgeTab && /*#__PURE__*/_jsx(ProfileTab, {
            to: PROFILE_ROUTES.badges,
            isActive: isBadgesActive,
            icon: "star",
            count: badgesAwardedCount,
            children: t('badges_title')
          }), /*#__PURE__*/_jsx(ProfileTab, {
            to: PROFILE_ROUTES.history,
            isActive: isHistoryActive,
            icon: "undo",
            children: t('history_title')
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(Routes, {
      children: [LEGACY_PROFILE_ROUTES.map(function (route) {
        return /*#__PURE__*/_jsx(Route, {
          path: route,
          element: /*#__PURE__*/_jsx(Navigate, {
            to: firstTabToDisplay,
            replace: true
          })
        }, route);
      }), /*#__PURE__*/_jsx(Route, {
        path: "to-do",
        element: /*#__PURE__*/_jsx(Navigate, {
          to: PROFILE_ROUTES.upcoming,
          replace: true
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: PROFILE_REL.root,
        element: /*#__PURE__*/_jsx(Navigate, {
          to: firstTabToDisplay,
          replace: true
        })
      }), hasSkillsTab && /*#__PURE__*/_jsx(Route, {
        path: "".concat(PROFILE_REL.skills, "/*"),
        element: /*#__PURE__*/_jsx(UserSkillsWidget, {
          userAnalysisRoutes: {
            root: PROFILE_ROUTES.skills,
            skill: PROFILE_ROUTES.skillsSkill,
            meeting: PROFILE_ROUTES.skillsMeeting
          }
        })
      }), hasUpcomingTab && /*#__PURE__*/_jsx(Route, {
        path: PROFILE_REL.upcoming,
        element: /*#__PURE__*/_jsx(Upcoming, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: PROFILE_REL.saved,
        element: /*#__PURE__*/_jsx(Saved, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: PROFILE_REL.history,
        element: /*#__PURE__*/_jsx(History, {})
      }), hasBadgeTab && /*#__PURE__*/_jsx(Route, {
        path: PROFILE_REL.badges,
        element: /*#__PURE__*/_jsx(Badges, {
          badgesLockedCount: badgesLockedCount,
          badgesAwardedCount: badgesAwardedCount
        })
      })]
    })]
  });
}
export default ProfilePage;